<div class="favorites-container" fxLayout="row" fxLayoutAlign="center center">
	<div *ngIf="menuItems" fxLayout="row" class="">
		<div class="mx-1" *ngFor="let menu of menuItems">
			<a *ngIf="menuService.activeModule && menu.routerLink && menu.routerLink !== '/'" [attr.title]="menu.desc" [routerLink]="[menu.routerLink]" (click)="setActiveModule(menu.routerLink)"
							[class.active-link]="menuService.activeModule.routerLink===menu.routerLink || menuItems.length === 1" [class.grow]="menuService.activeModule.routerLink!==menu.routerLink"
							mat-button fxLayout="row">
				<mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
				<span class="menu-title">{{menu.title}}</span>
			</a>
		</div>
	</div>
</div>